var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export { default as generateUtilityClass } from '@mui/base/generateUtilityClass';
export { default as generateUtilityClasses } from '@mui/base/generateUtilityClasses';
import composeClasses from '@mui/base/composeClasses';
import * as React from 'react';
export { composeClasses };
export function useMergedClasses(allClasses, getUtilityClass, propClasses) {
    if (propClasses === void 0) { propClasses = {}; }
    var slotMap = React.useMemo(function () {
        return Object.keys(allClasses).reduce(function (prev, key) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = [key], _a)));
        }, {});
    }, [allClasses]);
    return composeClasses(slotMap, getUtilityClass, propClasses);
}
